// extracted by mini-css-extract-plugin
export default {"heading":"Dz-z","corrected":"Ez-z","redirectVerbiageContainer":"Fz-z","redirectVerbiageText":"Gz-z"};